import { Component, OnInit } from '@angular/core';
import {Field} from "../../models/field.model";

@Component({
  selector: 'tig-form-datatable',
  templateUrl: './form-datatable.component.html',
  styleUrls: ['./form-datatable.component.scss']
})
export class FormDatatableComponent extends Field {

	// Noetig um ueber properties eines Objekts zu iterieren
	public objectKeys = Object.keys;
}
